import { ROUTES_NAME } from "../../config/constants";
import { authenticatedFetch } from "../../util/authenticatedFetch";
import { GDPR_REQUEST, GDPR_SUCCESS, GDPR_ERROR } from "./ActionType";

let requestSequence = 0;

const nextRequestId = () => `gdpr-request-${++requestSequence}`;

const readResponsePayload = async (response) => {
  if (typeof response?.text === "function") {
    const text = await response.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (_error) {
      return text;
    }
  }
  if (typeof response?.json === "function") {
    return response.json();
  }
  return null;
};

const responseError = (payload, response) => {
  const message =
    (typeof payload === "string" && payload.trim() && payload) ||
    [payload?.message, payload?.error, payload?.detail].find(
      (value) => typeof value === "string" && value.trim()
    );
  return message || `GDPR requests could not be loaded (${response?.status || "unknown status"}).`;
};

const errorText = (error) =>
  typeof error?.message === "string" && error.message.trim()
    ? error.message
    : "GDPR requests could not be loaded.";

export const getgdprData = (payload) => {
  const { type, page } = payload;
  return async (dispatch) => {
    const requestId = nextRequestId();
    const requestMeta = { requestId, type, page };
    dispatch(gdprSearchRequest(requestMeta));
    const pageSize = 10;
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.gdpr(
      type, page, pageSize
    )}`;

    try {
      const response = await authenticatedFetch(url, {
        method: "GET",
        credentials: "include",
      });
      const data = await readResponsePayload(response);

      if (!response?.ok) {
        throw new Error(responseError(data, response));
      }
      if (!data || typeof data !== "object" || !Array.isArray(data.content)) {
        throw new Error("GDPR requests returned an invalid response.");
      }

      dispatch(gdprSearchSuccess(data, requestMeta));
      return { ok: true, data };
    } catch (error) {
      const message = errorText(error);
      dispatch(gdpSearchError(message, requestMeta));
      return { ok: false, error: message };
    }
  };
};

function gdprSearchRequest(meta) {
  return {
    type: GDPR_REQUEST,
    meta,
  };
}

function gdprSearchSuccess(receivedData, meta) {
  return {
    type: GDPR_SUCCESS,
    payload: receivedData,
    meta,
  };
}

function gdpSearchError(receivedData, meta) {
  return {
    type: GDPR_ERROR,
    payload: receivedData,
    error: true,
    meta,
  };
}
